import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareDoNotTumbleDryIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.258 2.337a.851.851 0 0 1 1.193-.163l3.145 2.39v-.95a.64.64 0 0 1 .64-.64h14.176a.64.64 0 0 1 .639.64v.612l2.478-2.014a.855.855 0 0 1 1.204.125l.267.327-3.949 3.21v10.439l3.424 2.602a.852.852 0 0 1 .162 1.193l-.259.34-3.327-2.53v1.038a.64.64 0 0 1-.639.64H5.236a.64.64 0 0 1-.64-.64v-.52L.959 21.393l-.267-.328a.857.857 0 0 1 .124-1.204l3.78-3.072V6.17L0 2.676Zm15.483 12.305a4.779 4.779 0 0 1-6.668.156l-3.198 2.599v.92h12.898v-1.37Zm-9.866-7.5v8.608l2.383-1.937a4.765 4.765 0 0 1-.728-2.527c0-.873.237-1.69.647-2.395L5.876 7.14Zm12.898-.23L16.427 8.82a4.762 4.762 0 0 1 .08 4.8l2.266 1.722V6.913Zm-6.378 5.186-2.309 1.876a3.48 3.48 0 0 0 2.237.826c.922 0 1.755-.363 2.383-.945l-2.311-1.757ZM9.213 9.68a3.485 3.485 0 0 0-.405 1.606c0 .622.176 1.198.46 1.705l2.079-1.69Zm6.2-.037-1.998 1.625 2.051 1.56a3.47 3.47 0 0 0 .372-1.542 3.47 3.47 0 0 0-.425-1.643Zm-3.09-1.874c-.896 0-1.706.347-2.326.9l2.37 1.803 2.25-1.83a3.487 3.487 0 0 0-2.295-.873Zm6.45-3.515H5.874v1.283l3.08 2.342a4.773 4.773 0 0 1 6.674-.058l3.144-2.556V4.254Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { productCareDoNotTumbleDryIcon as default };
//# sourceMappingURL=productCareDoNotTumbleDryIcon.js.map
